// @intent: Browser entrypoint for the isolated playable runtime iframe
// @flow: Vite loads this file -> React mounts RuntimeApp -> postMessage protocol drives Pixi render
// @stale: when runtime app gains routing or multiple playable surfaces

import { createRoot } from 'react-dom/client';
import { RuntimeApp } from './RuntimeApp';
import './styles.css';

const root = document.getElementById('root');
if (!root) throw new Error('runtime root element missing');

createRoot(root).render(<RuntimeApp />);
